<template>
    <footer id="footer" class="pt-2">
        <loader :is-visible="isLoading"></loader>
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-3">
                    <div class="about-text">
                        <h3>About Our Store</h3>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. LoremIpsum has been the industry's standard dummy industry.</p>
                        <ul class="social-media list-inline mt-4">
                            <li class="list-inline-item">
                                <a href="" target="_blank" title="twitter">
                                    <i class="fab fa-2x fa-twitter"></i>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="" target="_blank" title="facebook">
                                    <i class="fab fa-2x fa-facebook-f"></i>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="" target="_blank" title="instagram">
                                    <i class="fab fa-2x fa-instagram"></i>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="" target="_blank" title="pinterest">
                                    <i class="fab fa-2x fa-youtube"></i>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="" target="_blank" title="vimeo">
                                    <i class="fab fa-2x fa-google"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="menu-text">
                        <h3>Products</h3>
                        <ul>
                            <li>
                                <a href="">Prices drop</a>
                            </li>
                            <li>
                                <a href="">New products</a>
                            </li>
                            <li>
                                <a href="">Best sales</a>
                            </li>
                            <li>
                                <a href="">Contact us</a>
                            </li>
                            <li>
                                <a href="">Sitemap</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="menu-text">
                        <h3>Our Company</h3>
                        <ul>
                            <li>
                                <a href="">Delivery</a>
                            </li>
                            <li>
                                <a href="">Legal Notice</a>
                            </li>
                            <li>
                                <a href="">Terms and conditions of use</a>
                            </li>
                            <li>
                                <a href="">About us</a>
                            </li>
                            <li>
                                <a href="">Secure payment</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="menu-text">
                        <h3>Address Information</h3>
                        <p>True Wholesale - Stationery Store 507-Union Trade ipsum Doler Centre France</p>
                        <p>000-000-0000</p>
                        <p>sales@yourcompany.com</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-after">
            <div class="container">
                <div class="copyright">
                    <a class="_blank" href="" target="_blank">
                        © 2021 - True Wholesale | Design by Provis Technologies Pvt Ltd
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    import loader from './Loader.vue'

    export default {
        components: { loader },
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                isLoading: false,
                axiosInterceptor: null,
            };
        },
        mounted() {
            this.enableInterceptor()
        },
        methods: {
            enableInterceptor() {
                this.axiosInterceptor = window.axios.interceptors.request.use((config) => {
                    this.isLoading = true
                    return config
                }, (error) => {
                    this.isLoading = false  
                    return Promise.reject(error)
                })
                
                window.axios.interceptors.response.use((response) => {
                    this.isLoading = false    
                    return response
                }, function(error) {
                    this.isLoading = false
                    return Promise.reject(error)
                })
            },
            
            disableInterceptor() {
                window.axios.interceptors.request.eject(this.axiosInterceptor)
            },     
        },
    };
</script>
